import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

/**
 * SSG was having issues where a press of the Browser Back button inside of SSG was causing a popstate event to be received by PSG.
 * PSG was redirected at the time to the EmployeePayComponent, and so this made the Dashboard not appear.
 *
 * This *ignores* the popstate event and instead waits for an imperative routing, IF the component's route adds this as a Guard.
 * @see HomeComponent.navOverridesEePay
 * @link https://ulti.quip.com/pL0HAUaYfif1/ULTI-449595-Back-Button-Shenanigans
 */
@Injectable()
export class RouterPopstatePreventer implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const nav = this.router.getCurrentNavigation();
    return nav.trigger !== 'popstate';
  }

}
